<template>
	<div class="home">
		<Header :active="2"></Header>
		<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/tu.png" alt="上职家、蓝领、区块链、人力资源、企业直招">
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	export default {
		name: "",
		components: {
			Header
		},
		metaInfo: {
			title: '招商加盟'
		},
		data() {
			return {

			}
		},
		mounted() {
			// let params = {tableDataEnum: 'INTERVIEWWORKPERIODENUM'}
			// this.http.get('/getTableDataByParam',params).then(res => {
			// 	console.log(res);
			// }).catch(()=>{})
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.home{
		width: 100%;
		position: relative;
		height: 100vh;
	}
	img {
		width: 1116px;
		height: 559px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
</style>
